import { Autocomplete, CircularProgress, TextField } from "@mui/material"

/**
 * Componente InputAutocompleteId.
 *
 * @description
 * Retorna únicamente el valor del campo especificado (`dataId`) y muestra la etiqueta especificada (`dataLabel`).
 * Permite manejar estado de carga y selección de manera controlada.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Array<Object>} props.data - Arreglo de objetos que contiene las áreas disponibles.
 * @param {string} [props.dataLabel="description"] - Nombre de la propiedad de cada objeto que se mostrará como label.
 * @param {string} [props.dataId="id"] - Nombre de la propiedad de cada objeto que se usará como valor.
 * @param {boolean} props.loading - Indica si los datos se están cargando.
 * @param {string} props.label - Texto que se muestra como label del input.
 * @param {any} props.value - Valor seleccionado actualmente (correspondiente a `dataId`).
 * @param {function} props.setValue - Función para actualizar el valor seleccionado.
 *
 * @returns {JSX.Element} Componente Autocomplete para seleccionar un área.
 */

export function InputAutocompleteId({
	data,
	dataLabel = "description",
	dataId = "id",
	loading,
	label,
	value,
	setValue,
}) {
	return (
		<Autocomplete
			options={data}
			getOptionLabel={(option) => (option ? option[dataLabel] ?? "" : "")}
			value={data.find((opt) => opt[dataId] === value) || null}
			isOptionEqualToValue={(option, val) =>
				val ? option[dataId] === val[dataId] : false
			}
			onChange={(e, newValue) => setValue(newValue ? newValue[dataId] : null)}
			loading={loading} // 👈 activa el estado de carga
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{loading ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment} {/* esto debe ir al final */}
							</>
						),
					}}
				/>
			)}
			loadingText="Cargando..."
		/>
	)
}
